import React, { useEffect } from 'react';
import './AboutUs.css';

function AboutUs() {
  useEffect(() => {  
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className='about-us'>
      <div className='about-us-hero'>
        <h2>About DJ's Dog Bar</h2>
        <p>Where dogs and their humans come together to create unforgettable memories</p>
      </div>

      <div className='about-us-content'>
        <div className='about-us-section'>
          <h3>Our Story</h3>
          <p>
            DJ's Dog Park Bar is a locally-owned business founded by a group of passionate dog lovers from Maryland. We've always cherished the companionship of dogs and understand the special bond that exists between pets and their owners. Our vision has always been to create a unique space where dogs and their humans can have a great time, enjoying each other's company in a welcoming and engaging environment.
          </p>
        </div>

        <div className='about-us-section'>
          <h3>Our Mission</h3>
          <p>
            Our dog park bar is more than just a place for your furry friends to run around; it's a hub for the community to come together, unwind, and celebrate the joy that dogs bring to our lives. Whether you're coming in for an off-leash adventure or just a relaxing drink with other dog lovers, we want everyone to feel at home.
          </p>
        </div>

        <div className='about-us-section'>
          <h3>Our Facilities</h3>
          <p>
            The space features thoughtfully designed amenities, including spacious turf play areas, shaded seating for owners, and attentive staff dedicated to ensuring all dogs have a positive experience. With a great selection of drinks for you and a stimulating environment for your pup, DJ's Dog Park Bar is a place where everyone can enjoy themselves.
          </p>
        </div>

        <div className='about-us-section'>
          <h3>Our Community</h3>
          <p>
            We believe in fostering a true sense of community—one where both dogs and people can create memories, form friendships, and share in a collective love for our canine companions. Our staff members are passionate, knowledgeable, and always happy to help make your experience as enjoyable as possible.
          </p>
        </div>
      </div>

      <div className='about-us-cta'>
        <p>
          Come join us and discover what makes DJ's Dog Park Bar a special place for both you and your dog. We look forward to welcoming you soon!
        </p>
      </div>
    </div>
  );
}

export default AboutUs;
